import { ProfileService } from './../../core/services/profile/profile.service';
import { NgControl } from '@angular/forms';
import { NoDecimalPipe } from './../pipes/no-decimal.pipe';
import { Directive, ElementRef, HostListener } from '@angular/core';
import { transformToNumber } from '@shared/utils/format-number';
import { NumberPipe } from '@shared/pipes/number.pipe';

@Directive({
  selector: '[noDecimalFormatter]'
})
export class NoDecimalFormatterDirective {
  private el: HTMLInputElement;

  constructor(
    private numberPipe: NumberPipe,
    private elementRef: ElementRef,
    private control: NgControl,
    private profile: ProfileService
  ) {
    this.el = this.elementRef.nativeElement;
  }
  /**
   * Focus event to execute
   * @param value
   */
  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = this.control.control.value;
  }
  /**
   * Blur event to execute
   * @param value
   */
  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    const numberValue = transformToNumber(value, this.profile.getGroupingSymbol(), this.profile.getDecimalSymbol());
    this.control.control.setValue(numberValue);
    this.el.value = this.numberPipe.transformNoDecimal(value);
  }
}
